export enum DepotRequestType {
    Scan = 'Scan',
    Consult = 'Consult',
    Borrow = 'Borrow'
}
